import { ReactNode } from 'react'

import * as SC from './styles'

type Props = {
  children: ReactNode
  withoutPadding?: boolean
}

export const SidePanelContent = (props: Props) => {
  const { children, withoutPadding = false } = props

  return <SC.Content $withoutPadding={withoutPadding}>{children}</SC.Content>
}
